// extracted by mini-css-extract-plugin
module.exports =  {"label":"a10a3f92e9--label--3xVvD","logo":"a10a3f92e9--logo--QGiT1","img":"a10a3f92e9--img--N0zsV","builder":"a10a3f92e9--builder--mS6Z4"};